









import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class NotificationIcon extends Vue {
	@Getter('getUnreadNotifications', { namespace: 'Notifications' })
	private getUnreadNotifications: any;
}
